import { render, staticRenderFns } from "./user-followup-2.vue?vue&type=template&id=3c769076&scoped=true"
import script from "./user-followup-2.vue?vue&type=script&lang=js"
export * from "./user-followup-2.vue?vue&type=script&lang=js"
import style0 from "./user-followup-2.vue?vue&type=style&index=0&id=3c769076&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c769076",
  null
  
)

export default component.exports